import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';

function LinkPage() {
    const Token = JSON.parse(localStorage.getItem('tcn'));
    const localStorageUserId = JSON.parse(localStorage.getItem('userid'));
    const { enqueueSnackbar } = useSnackbar();

    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    const [ddlPageURLMaster, setddlPageURLMaster] = useState([]);

    const [edit, setEdit] = useState(false);

    const [LinkPageId, setLinkPageId] = useState(0);
    const [Heading, setHeading] = useState('');
    const [URLId, setURLId] = useState(0);
    const [LinkURLId, setLinkURLId] = useState(0);
    const [Value, setValue] = useState('');
    const [IsActive, setIsActive] = useState(true);
    const [CreatedBy] = useState(localStorageUserId || 0);

    const [State, setState] = useState('');
    const [City, setCity] = useState('');
    const [PropertyTypeName, setPropertyTypeName] = useState('');
    const [PageURL, setPageURL] = useState('');

    const [LinkedState, setLinkedState] = useState('');
    const [LinkedCity, setLinkedCity] = useState('');
    const [LinkedPropertyTypeName, setLinkedPropertyTypeName] = useState('');
    const [LinkedPageURL, setLinkedPageURL] = useState('');

    const [search, setsearch] = useState('');
    const [lstLinkPage, setlstLinkPage] = useState([]);
    const [filterLinkPage, setfilterLinkPage] = useState([]);

    const pageURLSelectRef = useRef(null);
    const linkedURLSelectRef = useRef(null);
    const HeadingRef = useRef(null);


    const coloumn = [
        {
            name: 'SNo.',
            selector: (row, index) => index + 1,
            maxWidth: '70px'
        },
        {
            name: 'Main Page URL',
            selector: (row) => `${row.PageURL || ''} ${row.State || ''} ${row.City || ''}`,
            sortable: true,
            grow: 2,
            wrap: true,
            cell: (row) => (
                <div className="py-2">
                    <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">{row.PageURL || '-'}</p>
                    <p className="text-xs text-slate-600 break-words whitespace-normal mt-1">{row.State || '-'} | {row.City || '-'} | {row.PropertyTypeName || '-'}</p>
                </div>
            )
        },
        {
            name: 'Linked Page URL',
            selector: (row) => `${row.Linked_PageURL || ''} ${row.Linked_State || ''} ${row.Linked_City || ''}`,
            sortable: true,
            grow: 2,
            wrap: true,
            cell: (row) => (
                <div className="py-2">
                    <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">{row.Linked_PageURL || '-'}</p>
                    <p className="text-xs text-slate-600 break-words whitespace-normal mt-1">{row.Linked_State || '-'} | {row.Linked_City || '-'} | {row.Linked_PropertyTypeName || '-'}</p>
                </div>
            )
        },
        {
            name: 'Link Details',
            selector: (row) => `${row.Heading || ''} ${row.Value || ''}`,
            sortable: true,
            grow: 3,
            wrap: true,
            cell: (row) => (
                <div className="py-2">
                    <p className="text-sm font-semibold text-slate-800 break-words whitespace-normal">{row.Heading || '-'}</p>
                    <p className="text-xs text-slate-700 break-words whitespace-normal mt-1"><span className="font-semibold">Value:</span> {row.Value || '-'}</p>
                </div>
            )
        },
        {
            name: 'Status',
            cell: (row) => row.IsActive
                ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label>
                : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivated</label>,
            grow: 1
        },
        {
            name: 'Action',
            grow: 1,
            cell: (row) => (
                <div className="flex items-center gap-2 py-2">
                    <button
                        type="button"
                        onClick={() => handleEditLinkPage(row)}
                        className="text-white bg-gradient-to-r from-sky-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-sky-200 font-medium rounded-lg text-sm px-3 py-2"
                        title="Edit LinkPage"
                    >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    {
                        row.IsActive
                            ?
                            <button
                                type="button"
                                onClick={() => activateDeactivateLinkPage(row.LinkPageId, 'deactivate')}
                                className="text-white bg-gradient-to-r from-green-500 to-emerald-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-200 font-medium rounded-lg text-sm px-3 py-2"
                                title="Deactivate LinkPage"
                            >
                                <i className="fa fa-toggle-on" aria-hidden="true"></i>
                            </button>
                            :
                            <button
                                type="button"
                                onClick={() => activateDeactivateLinkPage(row.LinkPageId, 'activate')}
                                className="text-white bg-gradient-to-r from-red-500 to-rose-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-200 font-medium rounded-lg text-sm px-3 py-2"
                                title="Activate LinkPage"
                            >
                                <i className="fa fa-toggle-off" aria-hidden="true"></i>
                            </button>
                    }
                </div>
            )
        }
    ];

    useEffect(() => {
        getddlPageURLMaster();
        getAllLinkPage();
    }, []);

    useEffect(() => {
        const query = (search || '').toLowerCase();

        const result = lstLinkPage.filter((x) => {
            const searchableValues = [
                x?.Heading,
                x?.Value,
                x?.PageURL,
                x?.State,
                x?.City,
                x?.PropertyTypeName,
                x?.Linked_PageURL,
                x?.Linked_State,
                x?.Linked_City,
                x?.Linked_PropertyTypeName
            ];

            return searchableValues.some((value) => String(value || '').toLowerCase().includes(query));
        });

        setfilterLinkPage(result);
    }, [search, lstLinkPage]);

    useEffect(() => {
        if (!id || isNaN(id) || ddlPageURLMaster.length === 0) {
            return;
        }

        handleDDLChange(id);
    }, [id, ddlPageURLMaster]);

    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    };

    const getddlPageURLMaster = async () => {
        try {
            const response = await fetch(APIUrl.PageURLMaster + 'GetAllPageURLMaster', {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success') {
                setddlPageURLMaster(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const normalizeTagList = (list) => {
        const mapper = new Map();

        (list || []).forEach((item) => {
            const key = `${Number(item?.URLId || 0)}_${Number(item?.LinkURLId || 0)}`;
            const existing = mapper.get(key);

            if (!existing || Number(item?.LinkPageId || 0) > Number(existing?.LinkPageId || 0)) {
                mapper.set(key, item);
            }
        });

        return Array.from(mapper.values());
    };

    const getAllLinkPage = async () => {
        try {
            const response = await fetch(APIUrl.LinkPage + 'GetAllLinkPage', {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success' && Array.isArray(result.data)) {
                const normalizedList = normalizeTagList(result.data);
                setlstLinkPage(normalizedList);
                setfilterLinkPage(normalizedList);
                return normalizedList;
            }

            setlstLinkPage([]);
            setfilterLinkPage([]);
            return [];
        }
        catch (error) {
            console.log(error);
            setlstLinkPage([]);
            setfilterLinkPage([]);
            return [];
        }
    };

    const fnGetMyLinkPageByURLId = async (id) => {
        try {
            const response = await fetch(APIUrl.LinkPage + 'GetLinkPageByURLId/' + id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                }
            });

            const result = await parseJSON(response);
            if (result?.Message === 'Success' && result.data) {
                const linkPageData = result.data;
                setLinkPageId(linkPageData.LinkPageId || 0);
                setHeading(linkPageData.Heading || '');
                setValue(linkPageData.Value || '');
                setLinkURLId(linkPageData.LinkURLId || 0);
                setLinkedState(linkPageData.Linked_State || '');
                setLinkedCity(linkPageData.Linked_City || '');
                setLinkedPageURL(linkPageData.Linked_PageURL || '');
                setLinkedPropertyTypeName(linkPageData.Linked_PropertyTypeName || '');
                setIsActive(linkPageData.IsActive ?? true);
                setEdit(true);
            }
            else {
                setLinkPageId(0);
                setHeading('');
                setValue('');
                setLinkURLId(0);
                setLinkedState('');
                setLinkedCity('');
                setLinkedPageURL('');
                setLinkedPropertyTypeName('');
                setIsActive(true);
                setEdit(false);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const handleDDLChange = async (selectedId) => {
        debugger
        const normalizedURLId = Number(selectedId || 0);
        const filterPageURLMaster = ddlPageURLMaster.find((x) => Number(x.URLId) === normalizedURLId);

        if (filterPageURLMaster) {
            setState(filterPageURLMaster.State || '');
            setCity(filterPageURLMaster.City || '');
            setPageURL(filterPageURLMaster.PageURL || '');
            setPropertyTypeName(filterPageURLMaster.PropertyTypeName || '');
            setURLId(filterPageURLMaster.URLId || 0);
           // await fnGetMyLinkPageByURLId(filterPageURLMaster.URLId);
            setLinkedState(filterPageURLMaster.Linked_State || '');
            setLinkedCity(filterPageURLMaster.Linked_City || '');
            setLinkedPageURL(filterPageURLMaster.Linked_PageURL || '');
            setLinkedPropertyTypeName(filterPageURLMaster.Linked_PropertyTypeName || '');
            setLinkURLId(filterPageURLMaster.LinkURLId || 0);
        }
        else {
            setState('');
            setCity('');
            setPageURL('');
            setPropertyTypeName('');
            setURLId(0);
            setLinkPageId(0);
            setHeading('');
            setValue('');
            setLinkURLId(0);
            setLinkedState('');
            setLinkedCity('');
            setLinkedPageURL('');
            setLinkedPropertyTypeName('');
            setIsActive(true);
            setEdit(false);
        }

        if (normalizedURLId === 0) {
            resetForm();
        }
    };

    const handleLinkedURLChange = (selectedId) => {
        debugger;
        const normalizedLinkedURLId = Number(selectedId || 0);
        const filterLinkedPageURL = ddlPageURLMaster.find((x) => Number(x.URLId) === normalizedLinkedURLId);

        if (filterLinkedPageURL) {
            setLinkedState(filterLinkedPageURL.State || '');
            setLinkedCity(filterLinkedPageURL.City || '');
            setLinkedPageURL(filterLinkedPageURL.PageURL || '');
            setLinkedPropertyTypeName(filterLinkedPageURL.PropertyTypeName || '');
            setLinkURLId(filterLinkedPageURL.URLId || 0);
        }
        else {
            setLinkedState('');
            setLinkedCity('');
            setLinkedPageURL('');
            setLinkedPropertyTypeName('');
            setLinkURLId(0);
        }
    };

    async function activateDeactivateLinkPage(Id, Value) {
        try {
            const data = { Value };
            const response = await fetch(APIUrl.LinkPage + 'ActivateDeactivateLinkPage/' + Id, {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });

            const result = await parseJSON(response);
            if (result) {
                await getAllLinkPage();
                Value === 'activate'
                    ? enqueueSnackbar('Successfully Activated', { variant: 'success' })
                    : enqueueSnackbar('Successfully Deactivated', { variant: 'warning' });
            }
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar('Failed to update LinkPage status.', { variant: 'error' });
        }
    }

    const handlePopulateonEdit=(selectedId)=>{
         debugger
        const normalizedURLId = Number(selectedId || 0);
        const filterPageURLMaster = lstLinkPage.find((x) => Number(x.URLId) === normalizedURLId);

        if (filterPageURLMaster) {
            setState(filterPageURLMaster.State || '');
            setCity(filterPageURLMaster.City || '');
            setPageURL(filterPageURLMaster.PageURL || '');
            setPropertyTypeName(filterPageURLMaster.PropertyTypeName || '');
            setURLId(filterPageURLMaster.URLId || 0);
           
            setLinkedState(filterPageURLMaster.Linked_State || '');
            setLinkedCity(filterPageURLMaster.Linked_City || '');
            setLinkedPageURL(filterPageURLMaster.Linked_PageURL || '');
            setLinkedPropertyTypeName(filterPageURLMaster.Linked_PropertyTypeName || '');
            setLinkURLId(filterPageURLMaster.LinkURLId || 0);
            setHeading(filterPageURLMaster.Heading)
        }
        else {
            setState('');
            setCity('');
            setPageURL('');
            setPropertyTypeName('');
            setURLId(0);
            setLinkPageId(0);
            setHeading('');
            setValue('');
            setLinkURLId(0);
            setLinkedState('');
            setLinkedCity('');
            setLinkedPageURL('');
            setLinkedPropertyTypeName('');
            setIsActive(true);
            setEdit(false);
        }

        if (normalizedURLId === 0) {
            resetForm();
        }
    }

    function handleEditLinkPage(row) {
        if (!row?.URLId) {
            enqueueSnackbar('URLId not found for selected LinkPage.', { variant: 'warning' });
            return;
        }

        handlePopulateonEdit(row.URLId);
       
        setEdit(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const resetForm = () => {
        setLinkPageId(0);
        setURLId(0);
        setHeading('');
        setValue('');
        setLinkURLId(0);
        setLinkedState('');
        setLinkedCity('');
        setLinkedPageURL('');
        setLinkedPropertyTypeName('');
        setIsActive(true);
        setState('');
        setCity('');
        setPropertyTypeName('');
        setPageURL('');
        setEdit(false);
    };

    const validateAndSaveLinkPage = async () => {
        const validations = [
            { isInvalid: !Token, message: 'Please login first.' },
            { isInvalid: !URLId, message: 'Please Select Main Page URL.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !State.trim(), message: 'State is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !City.trim(), message: 'City is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PropertyTypeName.trim(), message: 'Property Type is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PageURL.trim(), message: 'Master Page URL is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !LinkURLId, message: 'Please Select Linked Page URL.', focus: () => linkedURLSelectRef.current?.focus() },
            { isInvalid: !LinkedState.trim(), message: 'Linked State is required.', focus: () => linkedURLSelectRef.current?.focus() },
            { isInvalid: !LinkedCity.trim(), message: 'Linked City is required.', focus: () => linkedURLSelectRef.current?.focus() },
            { isInvalid: !LinkedPageURL.trim(), message: 'Linked Page URL is required.', focus: () => linkedURLSelectRef.current?.focus() },
            { isInvalid: !Heading.trim(), message: 'Heading is required.', focus: () => HeadingRef.current?.focus() },
        ];

        const failedValidation = validations.find((item) => item.isInvalid);
        if (failedValidation) {
            enqueueSnackbar(failedValidation.message, { variant: 'warning' });
            failedValidation.focus?.();
            return;
        }

        try {
            const data = {
                LinkPageId,
                Heading: Heading.trim(),
                URLId,
                LinkURLId,
                Value: Value.trim(),
                IsActive,
                CreatedBy
            };

            const endpoint = edit
                ? APIUrl.LinkPage + 'UpdateLinkPage/' + LinkPageId
                : APIUrl.LinkPage + 'InsertLinkPage';

            const response = await fetch(endpoint, {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success' || result?.returnID > 0 || response.ok) {
                enqueueSnackbar(result?.Message || (edit ? 'Successfully Updated' : 'Successfully Added'), { variant: 'success' });

                await getAllLinkPage();
                await fnGetMyLinkPageByURLId(URLId);
                setEdit(true);
                return;
            }

            enqueueSnackbar(result?.Message || 'Failed to save LinkPage.', { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar(error?.message || 'Error while saving LinkPage.', { variant: 'error' });
        }
    };

    return (
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50">
                <div className="mx-auto w-full max-w-[1500px] rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div className="flex flex-col gap-3 border-b border-slate-200 p-4 sm:p-5 md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 className="text-xl font-semibold text-slate-900">Link Page</h1>
                            <p className="mt-1 text-sm text-slate-600"></p>
                        </div>
                        {/* <p className="text-xs font-medium text-slate-500">Dashboard - Details Category</p> */}
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 border-b border-slate-200 p-4 sm:p-5">
                        <div>
                            <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Main Page URL</label>
                            <select
                                ref={pageURLSelectRef}
                                value={String(URLId)}
                                onChange={(e) => handleDDLChange(e.target.value)}
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            >
                                <option value="0">Select Main Page URL</option>
                                {
                                    ddlPageURLMaster.map((item) => (
                                        <option key={item.URLId} value={String(item.URLId)}>{item.PageURL}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div>
                            <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Linked Page URL</label>
                            <select
                                ref={linkedURLSelectRef}
                                value={String(LinkURLId)}
                                onChange={(e) => handleLinkedURLChange(e.target.value)}
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            >
                                <option value="0">Select Linked Page URL</option>
                                {
                                    ddlPageURLMaster.filter(item => String(item.URLId) !== String(URLId)).map((item) => (
                                        <option key={item.URLId} value={String(item.URLId)}>{item.PageURL}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>

                    <div className="space-y-4 p-4 sm:p-5">
                        <div>
                            <h3 className="mb-3 text-sm font-semibold text-slate-900">Main Page Information</h3>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>State</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={State}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>City</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={City}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Property Type</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={PropertyTypeName}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Master Page URL</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={PageURL}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <hr className="border-slate-200" />

                        <div>
                            <h3 className="mb-3 text-sm font-semibold text-slate-900">Linked Page Information</h3>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Linked State</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={LinkedState}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Linked City</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={LinkedCity}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Linked Property Type</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={LinkedPropertyTypeName}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Linked Page URL</label>
                                    <input
                                        type='text'
                                        className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                        value={LinkedPageURL}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <hr className="border-slate-200" />

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Heading</label>
                                <textarea
                                    ref={HeadingRef}
                                    rows={2}
                                    className='w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={Heading}
                                    onChange={(e) => setHeading(e.target.value)}
                                    placeholder='Enter Heading'
                                />
                            </div>
                            
                        </div>

                        <div className="flex flex-wrap items-center gap-2 pt-2">
                            <button
                                type="button"
                                onClick={validateAndSaveLinkPage}
                                className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
                            >
                                {edit ? 'Update' : 'Save'}
                            </button>
                            <button
                                type="button"
                                onClick={resetForm}
                                className="rounded-md bg-slate-500 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-slate-600"
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>

                <div className="mt-6 rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                        <DataTable
                            title="Manage Link Page"
                            columns={coloumn}
                            data={filterLinkPage}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="500px"
                            highlightOnHover
                            subHeader
                            subHeaderAlign="right"
                            subHeaderComponent={
                                <input
                                    type="text"
                                    placeholder="Search Link Page"
                                    className="w-full sm:w-72 rounded-lg border border-slate-300 px-4 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                                    value={search}
                                    onChange={(e) => setsearch(e.target.value)}
                                />
                            }
                        />
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export default LinkPage;
